import { ready, onceInitialized } from '../../lib/lifecycle/ready';

const modulrAccordionItemSelect = (item) => {
  if (!item) {
    return;
  }

  const container = item.closest('.wp-block-modulr-accordion');
  if (!container) {
    return;
  }

  const items = container.querySelectorAll('.wp-block-modulr-accordion-item');

  [...items].forEach((i) => {
    if (i !== item) {
      i.classList.remove('active');
      i.setAttribute('aria-expanded', 'false');
    }
  });

  item.classList.toggle('active');
  item.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');
};

function initAccordion(root) {
  const scope = root || document;
  const items = [...scope.querySelectorAll('.wp-block-modulr-accordion-item')];

  items.forEach((item) => {
    if (!onceInitialized(item, 'accordion-item')) return;

    item.setAttribute('role', 'button');
    item.setAttribute('tabindex', '0');
    item.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');

    const onClick = () => modulrAccordionItemSelect(item);
    const onKeyDown = (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        modulrAccordionItemSelect(item);
      }
    };

    item.addEventListener('click', onClick);
    item.addEventListener('keydown', onKeyDown);
  });
}

ready(initAccordion, { scope: 'modulr-accordion' });
